import { ref } from 'vue';

/**
 * Composable to trigger allowance refresh across components
 * Used when operations consume tokens (registration, market creation with fees)
 */

const refreshTrigger = ref(0);

export function useAllowanceRefresh() {
  function triggerRefresh() {
    refreshTrigger.value++;
  }

  return {
    refreshTrigger,
    triggerRefresh,
  };
}
